import React from 'react';
import { useOutletContext } from 'react-router-dom';
import type { AssetRef } from '../../types/place';

import VideoPlayer from '../players/VideoPlayer';

interface VideoWidgetProps {
    videoInfo: AssetRef | null;
    name?: string;
}

const VideoWidget: React.FC<VideoWidgetProps> = ({videoInfo, name}) => {

    const videoId = videoInfo? videoInfo.id : null

    if (!videoId) return null;

    return (
        <div>
            <VideoPlayer video={videoId} name={name} />
        </div>
    );
};

export default VideoWidget;
